import React, { useEffect, useState } from 'react';
import {format} from 'date-fns';
import Card from '../component/Card.component';
import { getAssesments, getRatingComment } from '../../Details.service';
import { getUserStore } from '../../Product.service';
import { useStore } from '../../../../../context/Store';
import { getUser } from '../../../../../core/auth/auth';
import { AssesmentInterface, CommentInterface } from '../interface/AssesmentInterface';
import ModalConfirm from '../component/ModalConfirm';
import useModal from '../../../../../hooks/useModal';
import { useHistory, useParams} from "react-router-dom";
import Progress from '../../../../../component/progress/Progress.component';
import {getUserById} from '../../User.service';


interface IUserStore {
    EV_WERKS:string | null | undefined;
}

interface ParamTypes {
  id:string;
}

export default function Assessment() {
  const { selectedStore } = useStore();
  const [questionList, setQuestionList] = useState<AssesmentInterface[]>([]);
  const [load, setLoad] = useState(true);
  const [open, addModal] = useModal();
  const [myStoreInfo, setMyStoreInfo] = useState({
    EV_NAME1: "",
    EV_NAME2: "",
    EV_WERKS: "",
  })
  let { id } = useParams<ParamTypes>();
  const history = useHistory();


  const getAssesment = async () => {
    const userInfo = await getUser();

    const myStore:IUserStore|any = await getUserStore(userInfo.sAMAccountName).then((result) => result.data)
    setMyStoreInfo(myStore);

    // myStore.EV_WERKS
    if(myStore.EV_WERKS !== selectedStore.id) {
      addModal(true);
    } else {
      const comments = await getRatingComment().then(({data}) => data.filter((comment:CommentInterface) => comment.idAvaliacao.idLoja ===selectedStore.id));

      setTimeout(async() => {
        const result:AssesmentInterface[]  = await getAssesments().then(async({data}) => {

          const assesments = data.filter((assesment:AssesmentInterface) => assesment.idLoja === selectedStore.id && assesment.flAvaliadoLoja === false).map((assesment:AssesmentInterface) => {
            const commentDescription:CommentInterface = comments.find((comment:CommentInterface) => comment.idAvaliacao.id === assesment.id && comment.idUsuario !== userInfo.sAMAccountName)
            return {
              id: assesment.id,
              title: assesment.idUsuario,
              subTitle: commentDescription !== undefined ? commentDescription.dsComentario : '',
              score: assesment.vlrPerguntaNPS,
              date: format(new Date(assesment.createdAt), "dd/MM/yyyy"),
              store: assesment.idLoja,
            }
          })
          return assesments;
        });

        getFullName(result);
      }, 1.0*1000)
    }
  }

  const getFullName = (list:any[]) => {
   list.forEach(async(item) => {
      const name = await getUserById(item.title).then((result) => result.data)

      await name.user.status === false ? item.title="" : item.title=name.user.cn;

      setQuestionList(questionList => [...questionList, item]);
    });

    setLoad(false);
  }

  const confirmModal = () => {
    addModal(!open)
    history.push(`/loja/${id}`);
  }

  useEffect(() => {
    getAssesment();

  },[])

  return (
    <>
      <ModalConfirm  open={!!open} handleClick={() => addModal('')}
        onClickSubmit={confirmModal}
        title="Usuário não pertence a loja selecionada!"
        subtitle1={`Loja selecionada: ${selectedStore.id} ${selectedStore.NomeCompleto}`}
        subtitle2={`Loja do usuário: ${myStoreInfo.EV_NAME2}`}
        />
      <Progress  open={load} />
      {questionList !== null && load === false && <Card data={questionList} request={false} />}
    </>
  )
}
